import { DocusignAdminRecipientsLookup } from "features/Sheets";
import { PageLoader } from "@redriver/cinnamon";
import React from "react";

const ConfirmationStep = ({
  formData,
  scheduleReference,
  agreementReference,
  t,
  sheetName,
  dealerOfficeId,
  includeSecondClientSignatory,
}) => {
  const formatPhoneNumber = (data) => {
    const countryCode = data?.phoneCountryCode
      ? `(${data?.phoneCountryCode})`
      : "";
    const phoneNumber = data?.phoneNumber ? `${data?.phoneNumber}` : "";

    return countryCode + phoneNumber;
  };

  const renderCustomerSignatoryRow = (field, fieldName) => {
    return (
      <tr>
        <td>
          {field[`isNew_${fieldName}`]
            ? field.fullName
            : field.authorisedSignatory?.name?.split(" - "[0])}
        </td>
        <td>
          {field[`isNew_${fieldName}`]
            ? field.position
            : field.authorisedSignatory?.position}
        </td>
        <td>
          {field[`isNew_${fieldName}`]
            ? field.email
            : field.authorisedSignatory?.email}
        </td>
        <td>
          {field[`isNew_${fieldName}`]
            ? formatPhoneNumber(field)
            : formatPhoneNumber(field.authorisedSignatory)}
        </td>
      </tr>
    );
  };

  return (
    <DocusignAdminRecipientsLookup
      dealerOfficeId={dealerOfficeId}
      render={({ loading, response }) => {
        if (loading) {
          return <PageLoader />;
        }

        return (
          <React.Fragment>
            <p>{t("SheetActions.SendForApproval.ConfirmMessage")}</p>
            <p>{t("SheetActions.SendForApproval.Confirm")}</p>
            <p>
              {t("SheetActions.SendForApproval.SheetLabel")}
              <strong>{sheetName}</strong>
            </p>
            <p>
              {t("SheetActions.SendForApproval.ScheduleLabel")}
              <strong>{scheduleReference ?? t("NotLive")}</strong>
            </p>
            <p>
              {t("SheetActions.SendForApproval.AgreementLabel")}
              <strong>{agreementReference ?? t("NotLive")}</strong>
            </p>
            <h3>{t("SheetActions.SendForApproval.RecipientsTable.Title")}</h3>
            <table className="recipients">
              <thead>
                <tr>
                  <th>
                    {t("SheetActions.SendForApproval.RecipientsTable.FullName")}
                  </th>
                  <th>
                    {t("SheetActions.SendForApproval.RecipientsTable.Position")}
                  </th>
                  <th>
                    {t("SheetActions.SendForApproval.RecipientsTable.Email")}
                  </th>
                  <th>
                    {t(
                      "SheetActions.SendForApproval.RecipientsTable.PhoneNumber",
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {formData.usersToViewBeforeDocumentSigned?.map((u, i) => (
                  <tr key={`tr_${i}`}>
                    <td>{u.name}</td>
                    <td>
                      {t(
                        "SheetActions.SendForApproval.RecipientsTable.ViewUserPosition",
                      )}
                    </td>
                    <td>{u.email}</td>
                    <td>{formatPhoneNumber(u)}</td>
                  </tr>
                ))}

                {renderCustomerSignatoryRow(
                  formData.customerSignatory1,
                  "customerSignatory1",
                )}
                {includeSecondClientSignatory &&
                  renderCustomerSignatoryRow(
                    formData.customerSignatory2,
                    "customerSignatory2",
                  )}

                {formData.directDebitSignatories?.map((u, i) => (
                  <tr key={`tr_${i}`}>
                    <td>{u.name}</td>
                    <td>
                      {t(
                        "SheetActions.SendForApproval.RecipientsTable.DirectDebitSignatoryPosition",
                      )}
                    </td>
                    <td>{u.email}</td>
                    <td>{formatPhoneNumber(u)}</td>
                  </tr>
                ))}
                {response?.map((u, i) => (
                  <tr key={`tr_${i}`}>
                    <td>{u.name}</td>
                    <td>{u.position}</td>
                    <td>{u.email}</td>
                    <td>{formatPhoneNumber(u)}</td>
                  </tr>
                ))}
                {formData.usersToReceiveCopyOfSignedDocument?.map((u, i) => (
                  <tr key={`tr_${i}`}>
                    <td>{u.name}</td>
                    <td>
                      {t(
                        "SheetActions.SendForApproval.RecipientsTable.CopyUserPosition",
                      )}
                    </td>
                    <td>{u.email}</td>
                    <td>{formatPhoneNumber(u)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </React.Fragment>
        );
      }}
    />
  );
};

export default ConfirmationStep;
